export const SOFTLINE_API_FIELD_OK_VALIDATE = '/v1/bean/validate/{{fieldOk}}';
export const SOFTLINE_API_FIELD_OK_QUERY_DEFINITION =
  '/v1/bean/validationConfiguration/{{fieldOk}}';
export const SOFTLINE_API_FIELD_OK_QUERY = '/v1/bean/query/{{fieldOk}}';
export const SOFTLINE_API_FIELD_OK_RESULT =
  '/v1/bean/abfrageResult/{{fieldOk}}/{{key}}';

export const SOFTLINE_API_DEFINITION = "/v1/definitions/{{name}}"
